import React, { useState, useEffect } from 'react';
import '../Assets/css/header.css';
import Logo from '../Assets/img/logo_banner.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookSquare, faInstagram } from '@fortawesome/free-brands-svg-icons';
export const Header = () => {
    const [isNavVisible, setIsNavVisible] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const toggleNav = () => {
        setIsNavVisible(!isNavVisible);
    };

    return (
        <div className={`header ${isScrolled ? 'scrolled' : ''}`}>
            <div className="header-container">
                <div className="logo">
                    <img src={Logo} alt="Pluss Mineria" />
                </div>
                <div className="menu-toggle" onClick={toggleNav}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path d="M3 6h18v2H3zM3 12h18v2H3zM3 18h18v2H3z"/>
                    </svg>
                </div>
                <nav className={`${isNavVisible ? 'visible' : ''}`}>
                    <ul>
                        <li><a href="#nosotros">Nosotros</a></li>
                        <li><a href="#servicios">Servicios</a></li>
                        <li><a href="#flota">Flota</a></li>
                        <li><a href="#contacto">Contacto</a></li>
                        <li><a href="https://plusschile.cl" target="_blank">Grupo Pluss Chile</a></li>
                        <li>
                            <a href="https://www.facebook.com/TravelPussChile" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faFacebookSquare} size="1x"/>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/travelplusschile/" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faInstagram} size="1x"/>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    );
}

